module.exports = __webpack_public_path__ + "static/img/home_v6.e6aabfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/home_v6.svg
// module id = YxZv
// module chunks = 0